<template>
    <el-dialog :visible.sync="dialogVisible" class="dialog-large" :title="$STR('ORDER.createOrder.selectUnit', '选择单位')" @close="closeDialog">
        <div id="units-select">
            <el-table :empty-text="$STR('COMMON.data.empty', '暂无数据')" class="units-list"
                    @selection-change="handleSelectionChange" ref="unitTable"
                    :data="unitsList" style="width: 100%;overflow-y: auto" highlight-current-row>
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    :label="this.$STR('warehouse_outStock_unit', '单位名称')" :show-overflow-tooltip="true" prop="unitName">
                </el-table-column>
            </el-table>
            <div style="text-align: center;background: white; padding: 10px 0">
                <el-button @click="closeDialog">{{$STR('ORDER.unitsSelect.cancel', '取消操作')}}</el-button>
                <el-button :disabled="unitsSelection.length == 0" v-duplication @click="confirm" type="primary" plain>{{$STR('ORDER.unitsSelect.confirm', '确定选择')}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: ['visible', 'chosenUnitList'],
    computed: {
        dialogVisible: {
            get: function () { return this.visible; },
            set: function () { return; }
        }
    },
    watch: {
        dialogVisible (val) {
            if (!val) return;
            this.unitsSelection = JSON.parse(JSON.stringify(this.chosenUnitList));
            let selectedIds = [];
            this.unitsSelection.forEach(item => selectedIds.push(item.id));
            this.$nextTick(() => {
                this.unitsList.forEach(i => {
                    this.$refs['unitTable'].toggleRowSelection(i, selectedIds.includes(i.id));
                });
            });
        }
    },
    data () {
        return {
            unitsList: [],
            unitsSelection: []
        };
    },
    created() {
        this.getUnitList();
    },
    methods: {
        // 关闭弹窗
        closeDialog () {
            this.$parent.unitDialogVisible = false;
        },
        // 确定选择
        confirm () {
            this.$parent.chosenUnitList = this.unitsSelection;
            this.closeDialog();
        },
        // 获取单位
        getUnitList() {
            this.$http.get(WebApi.goods.goodsUnit).then(response => {
                this.unitsList = response.data.data;
            });
        },
        handleSelectionChange(val) {
            this.unitsSelection = val;
        }
    }
};
</script>

<style scoped>
    #units-select{
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/warehouse/unitSelect.vue